<script>import { melt } from "@melt-ui/svelte";
import { setItemCtx, getAttrs } from "../ctx.js";
import { createDispatcher } from "../../../internal/events.js";
export let value;
export let disabled = void 0;
export let label = void 0;
export let asChild = false;
const {
  elements: { option: item }
} = setItemCtx(value);
const dispatch = createDispatcher();
$:
  builder = $item({ value, disabled, label });
const attrs = getAttrs("item");
</script>

<!-- svelte-ignore a11y-no-static-element-interactions / applied by melt's builder-->

{#if asChild}
	<slot {builder} {attrs} />
{:else}
	<div
		{...builder} use:builder.action
		{...$$restProps}
		{...attrs}
		on:m-click={dispatch}
		on:m-pointermove={dispatch}
		on:focusin
		on:keydown
		on:focusout
		on:pointerleave
	>
		<slot {builder} {attrs}>
			{label ? label : value}
		</slot>
	</div>
{/if}
